interface LogoProps {
  className: string;
}

/** DC Thrift Shop logo as vector art, drawn in currentColor so it stays sharp at any size and on any background. */
export default function Logo(props: LogoProps): JSX.Element {
  return (
    <svg className={props.className} viewBox="0 4 200 80" fill="currentColor" role="img" aria-label="DC Thrift Shop">
      <rect x="72" y="42" width="8" height="10" rx="1.5" />
      <rect x="83" y="36" width="8" height="16" rx="1.5" />
      <rect x="94" y="30" width="8" height="22" rx="1.5" />
      <rect x="105" y="20" width="8" height="32" rx="1.5" />
      <path d="M101 22h16l-8-12Z" />
      <circle cx="126" cy="43" r="8.5" fill="none" stroke="currentColor" strokeWidth="2.5" />
      <text x="126" y="47.5" fontSize="12" fontWeight="800" textAnchor="middle">$</text>
      {/* textLength pins the wordmark width so a fallback font cannot overflow the viewBox. */}
      <text x="100" y="78" fontSize="21" fontWeight="800" letterSpacing="-0.5" textAnchor="middle" textLength="178"
        lengthAdjust="spacingAndGlyphs">DC THRIFT SHOP</text>
    </svg>
  );
}
